/**
 * Practice languages (completion plan P5).
 *
 * The same set the server accepts (backend domain/conversation/language.ts),
 * which is the platform's SUPPORTED_LANGUAGES (shared/src/constants/voice.ts).
 * The server validates every choice; this list only decides what is offered.
 */

export interface PracticeLanguageOption {
  code: string;
  label: string;
  /** The language's English name, used in UI copy ("Assess my Spanish"). */
  name: string;
}

export const PRACTICE_LANGUAGES: readonly PracticeLanguageOption[] = [
  { code: 'en-US', label: 'English (US)', name: 'English' },
  { code: 'en-GB', label: 'English (UK)', name: 'English' },
  { code: 'es-ES', label: 'Spanish (Spain)', name: 'Spanish' },
  { code: 'es-MX', label: 'Spanish (Mexico)', name: 'Spanish' },
  { code: 'fr-FR', label: 'French', name: 'French' },
  { code: 'de-DE', label: 'German', name: 'German' },
  { code: 'it-IT', label: 'Italian', name: 'Italian' },
  { code: 'pt-BR', label: 'Portuguese (Brazil)', name: 'Portuguese' },
  { code: 'ja-JP', label: 'Japanese', name: 'Japanese' },
  { code: 'zh-CN', label: 'Chinese (Simplified)', name: 'Chinese' },
];

/** The learner's base language, and the platform default. */
export const BASE_LANGUAGE = 'en-US';

export function practiceLanguageOption(code: string): PracticeLanguageOption | undefined {
  return PRACTICE_LANGUAGES.find((l) => l.code === code);
}

/** A language other than the base language (not just a regional variant of it). */
export function isTargetLanguage(code: string): boolean {
  return code.split('-')[0] !== BASE_LANGUAGE.split('-')[0];
}
